export enum MeasureKeyType {
    DISPONIBILITE_AVAILABLE_PC = 'availablePC',
    DISPONIBILITE_PARTIALLY_PC = 'partiallyPC',
    DISPONIBILITE_UNVAILABLE_PC = 'unavaiblePC',
    DISPONIBILITE_UNKNOWN_PC = 'unknownPC'
}
